export default "__VITE_ASSET__BrIsmvMC__"